module.exports = require("inquirer");